module.exports = __webpack_public_path__ + "static/media/csClub.3269a793.png";